import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { FaFolderPlus, FaKey } from 'react-icons/fa6';
import { useAlbumAssoc } from '../../api/queryHooks/pic';
import { normalizeAccessCode } from '../../api/albumAccessCode';
import { useAlbumWall } from '../../hooks/useAlbumWall';
import { useShopState } from '../../hooks/useShopState';
import { Loader } from '@f2m3/shared-frontend-ui';
import EntryCard from '../common/EntryCard';
import './AlbumAssoc.scss';

const AlbumAssoc = () => {
  const [albumCode, setAlbumCode] = useState('');
  const { mutate: albumAssoc, isPending } = useAlbumAssoc();
  const { t } = useTranslation();
  const { afterAlbumOpened } = useAlbumWall();
  const { closedForMe, pausedForMe } = useShopState();

  const code = normalizeAccessCode(albumCode);

  const handleAlbumAssoc = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (code) {
      albumAssoc(
        { albumCode: code },
        {
          onSuccess: (data) => afterAlbumOpened(data.album_id),
        },
      );
    }
  };

  // Opening an album mints a guest session for a visitor, which a shop that
  // is not open refuses; a paused shop refuses opening albums too (its
  // notice at the top says why).
  if (closedForMe || pausedForMe) return null;

  return (
    <EntryCard
      icon={<FaFolderPlus size={24} />}
      title={t('albumassoc.title')}
      subtitle={t('albumassoc.subtitle')}
    >
      <form onSubmit={handleAlbumAssoc} className="album-assoc-form">
        <div className="field">
          <label className="label">{t('albumassoc.albumcode')}</label>
          <div className="control has-icons-left">
            <input
              className="input"
              type="text"
              value={albumCode}
              onChange={(e) => setAlbumCode(e.target.value)}
              placeholder={t('albumassoc.albumcode_placeholder')}
              disabled={isPending}
              maxLength={20}
            />
            <span className="icon is-small is-left">
              <FaKey />
            </span>
          </div>
        </div>

        <div className="field">
          <div className="control">
            <button
              type="submit"
              className="button is-primary is-fullwidth"
              disabled={isPending || !code}
            >
              {isPending ? <Loader /> : t('albumassoc.open_album')}
            </button>
          </div>
        </div>
      </form>
    </EntryCard>
  );
};

export default AlbumAssoc;
